import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { getCduUser } from '@gef-ui/cdu-user/selectors';
import { ErrorAppbarButton } from '@gef-ui/error-report-material';
import { getMessage } from '@gef-ui/localization/messages';
import { Dashboard } from '@gef-ui/material/components/Dashboard';

import { useUserInfoDataLayer } from 'app/hooks';
import MODALS from 'constants/modals';
import { isOnProd } from 'utils/routeHelper';

import CustomDragLayer from './CustomDragLayer';
import LeftMenu from './Layout/Menu/Components/LeftMenu';
import AfterLogo from './Layout/Navbar/components/AfterLogo';
import Environment from './Layout/Navbar/components/Environment';
import Help from './Layout/Navbar/components/Help';
import RoleSwitch from './Layout/Navbar/components/RoleSwitch';
import User from './Layout/Navbar/components/User';
import SplitBackground from './Layout/SplitBackground';
import LightBoxModal from './LightBoxModal';

export const App = ({ children }) => {
	const cduUser = useSelector(getCduUser);
	useUserInfoDataLayer(cduUser);

	useEffect(() => {
		document.title = getMessage('common:gkcl');
	}, []);

	return (
		<Dashboard
			AppbarProps={{
				afterLogoElement: <AfterLogo />,
			}}
			sidebarElement={<LeftMenu />}
			sidebarWidth={280}
			SidebarProps={{ className: 'Drawer' }}
			appbarRightSideElements={[<Environment />, <Help />, <RoleSwitch />, <User />, <ErrorAppbarButton />]}
			sx={{
				'& main': {
					'@media print': {
						pt: 0,
					},
					position: 'relative',
					paddingX: 0,
					pt: 8.75,
					minWidth: 1050,
					pb: 0,
				},
				'& .Dashboard-container': {
					p: 0,
					backgroundColor: (theme) => theme.palette.background.neutral,
				},
				'& .Dashboard-aside': {
					minWidth: 325,
					height: '100%',
				},
				'& .MuiDrawer-root': {
					'.MuiPaper-root': {
						marginLeft: 1.25,
						marginTop: 1.25,
						borderRadius: 1,
					},
				},
				'& .Drawer': {
					'.MuiPaper-root': {
						overflowY: 'hidden',
					},
				},
				...(!isOnProd() && {
					'& header': {
						backgroundColor: (theme) => theme.palette.grey[700],
					},
				}),
			}}
		>
			<SplitBackground />
			<LightBoxModal id={MODALS.lightbox_modal} />
			<CustomDragLayer />
			{children}
		</Dashboard>
	);
};

App.propTypes = {
	children: PropTypes.node,
};

export default App;
